import { render } from "./Company.vue?vue&type=template&id=af7577b8&scoped=true&ts=true"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=af7577b8&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af7577b8"]])

export default __exports__